import { useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import './Layout.css';

function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const closeMenu = () => setMenuOpen(false);

  // Close menu on navigation
  const handleNavClick = () => setMenuOpen(false);

  return (
    <div className="site">
      <header className="top-bar">
        <div className="top-bar-inner">
          <NavLink to="/" className="site-name" onClick={handleNavClick}>Katie Schmid</NavLink>
          <button
            className={`hamburger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
          <nav className={`nav${menuOpen ? ' nav-open' : ''}`}>
            <NavLink to="/works" onClick={handleNavClick}>Works</NavLink>
            <NavLink to="/about" onClick={handleNavClick}>About</NavLink>
            <NavLink to="/cv" onClick={handleNavClick}>CV</NavLink>
            <NavLink to="/contact" onClick={handleNavClick}>Contact</NavLink>
          </nav>
        </div>
      </header>
      <main className="content">
        <Outlet />
      </main>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Katie Schmid Fine Art</p>
      </footer>
    </div>
  );
}

export default Layout;
